export default "__VITE_PUBLIC_ASSET__3d169b1f__"